module.exports = __webpack_public_path__ + "static/media/17UN-Women4.018e5e05.jpg";